import React from 'react'
import PropTypes from 'prop-types'
import Img from '../../Img'
import Hyperlink from '../../HyperLink'

const Index = ({ image, title, category, href }) => {
  const defaultImage = {
    src: '/next-assets/no_image.webp',
    alt: 'no image',
  }

  return (
    <div
      data-testid="read-item"
      className="gap-primary mb-14 grid grid-cols-2 pt-10 lg:grid-cols-1 lg:gap-y-0 lg:pt-0"
    >
      <Img
        src={image.src ? image.src : defaultImage.src}
        alt={image.alt ? image.alt : defaultImage.alt}
        layout="responsive"
        objectFit="cover"
        styles={{ position: 'relative' }}
      />
      <div className="lg:margin-t-primary-xs">
        <div className="border-t border-white lg:mt-9 lg:border-gray-300 lg:pt-9">
          <h3 className="mb-5 text-gray-245 lg:mb-6 lg:leading-7">
            {category}
          </h3>
          <div className="truncate-lines-4 overflow-hidden">
            <Hyperlink
              href={href}
              prefetch={false}
              childrenClassNames="text-xl text-blue-560 hover:underline md:text-2xl"
              title="Recommended reads"
            >
              {title}
            </Hyperlink>
          </div>
        </div>
      </div>
    </div>
  )
}

Index.defaultProps = {
  category: 'Uncategorized',
}
Index.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  category: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
}
export default Index
